"use strict";
var _a, _b;
var statsUrl = "https://ccd-typescript-api-5341184e38bc.herokuapp.com/googlereviews/stats";
fetch(statsUrl, {
    method: "GET",
    headers: {
        "Content-Type": "application/json",
        "x-api-key": "fda7b8af-a2ec-4609-895e-12f4bee2cf05"
    },
}).then(function (response) {
    response.json().then(function (json) {
        var _a;
        var data = json.data;
        if (data && data.averageRating && data.totalReviews) {
            var averageRating = data.averageRating;
            var averageRatingElement = document.querySelector('.google-customer-reviews .average-rating');
            if (averageRatingElement) {
                averageRatingElement.textContent = averageRating || "";
                (_a = document.querySelector('.google-customer-reviews .google-stars')) === null || _a === void 0 ? void 0 : _a.setAttribute('data-rating', averageRating);
                setGoogleCustomerStars('.google-customer-reviews .google-stars', 15);
                var windowWidth = window.innerWidth;
                if (windowWidth >= 768) {
                    setTimeout(function () {
                        var _a, _b;
                        (_a = document.querySelector('.google-customer-reviews-wrapper')) === null || _a === void 0 ? void 0 : _a.classList.remove('d-none');
                        (_b = document.querySelector('.google-customer-reviews-wrapper')) === null || _b === void 0 ? void 0 : _b.classList.add('d-flex');
                    }, 50);
                }
            }
        }
    });
}).catch(function (error) {
    console.log(error);
});
var localStorageKey = "google-customer-reviews-collapsed";
var lastUpdate = localStorage.getItem(localStorageKey);
if (lastUpdate) {
    (_a = document.querySelector(".google-customer-reviews-wrapper")) === null || _a === void 0 ? void 0 : _a.classList.add("slide-close");
}
(_b = document.querySelector(".google-customer-reviews-wrapper .close-button")) === null || _b === void 0 ? void 0 : _b.addEventListener("click", function () {
    var _a;
    var currentDate = new Date();
    var lastUpdate = currentDate.toISOString();
    localStorage.setItem(localStorageKey, lastUpdate);
    (_a = document.querySelector(".google-customer-reviews-wrapper")) === null || _a === void 0 ? void 0 : _a.classList.toggle("slide-close");
});
function setGoogleCustomerStars(selector, starWidth) {
    var elements = document.querySelectorAll(selector);
    elements.forEach(function (element) {
        var rating = Math.round(parseFloat(element.getAttribute('data-rating') || "5"));
        var width = Math.max(0, Math.min(5, rating)) * starWidth;
        var starSpan = document.createElement('span');
        starSpan.style.width = width + 'px';
        element.innerHTML = '';
        element.appendChild(starSpan);
    });
}
